import { RadioGroup } from '@mui/material';
import { RadioGroupProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props extends RadioGroupProps {
  design: FormPublicDesignFragment;
  children?: React.ReactNode;
}

const Field = styled(RadioGroup)<{ design: FormPublicDesignFragment }>`
  flex: 1;
  width: 100%;

  margin: 0 10px;
  background: none;

  color: ${({ design }) => design.colors.question};

  label {
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    padding: 1%;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export const StyledRadioGroup: React.FC<Props> = ({ children, ...props }) => {
  return <Field {...props}>{children}</Field>;
};
